// Maison Core — central configuration. Placeholders are clearly marked and editable.

const A = "https://customer-assets-v7afamib.emergentagent.net/job_ligne-lab/artifacts/";

// Official Maison Core full logo (Petal, transparent background)
export const LOGO = `${A}fhanmul1_Maison-Core-Full-Logo-Petal%20%282%29.webp`;

export const IMAGES = {
  // Real Maison Core studio photography — full foundation (no stock)
  studioInterior: `${A}gu8kdm1a__G2A6261.webp`,   // hero — reformer row with arches
  arch1: `${A}p5raqfwp__G2A6303.webp`,            // branded pillar
  arch2: `${A}4aggtuy7__G2A6300.webp`,            // wide reception / kitchenette
  studioWide: `${A}4bwtnvfe__G2A6294.webp`,       // wide reception (alt)
  detail: `${A}47nh3g7d__G2A6280.webp`,           // vanity detail
  vanityWide: `${A}3twm0rpw__G2A6283.webp`,       // double-sink vanity
  changing: `${A}4qv5ntpy__G2A6281.webp`,         // changing room bench
  equipRow: `${A}vz49ii0u__G2A6275.webp`,         // reformer row — balls & circles
  equipCarriage: `${A}9e488jan__G2A6273.webp`,    // reformer carriage close-up
  equipBall: `${A}c10ker7d__G2A6272.webp`,        // ball & magic-circle detail
  // Back-compat aliases (now pointing to real equipment crops)
  get movement1() { return this.equipCarriage; },
  get movement2() { return this.equipRow; },
};

// Bsport deep links (company 6040).
export const BSPORT = {
  COMPANY_ID: 6040,
  BOOK_CLASS_URL: "https://backoffice.bsport.io/m/Maison%20Core/6040/calendar/?isPreview=true",
  SCHEDULE_URL: "https://backoffice.bsport.io/m/Maison%20Core/6040/calendar/?isPreview=true",
  INTRO_URL: "https://backoffice.bsport.io/customer/payment/pass/760072/?membership=6040&force=true",
  CLASSIC_URL: "https://backoffice.bsport.io/checkout/6040/subscription/51688?force=true",
  SIGNATURE_URL: "https://backoffice.bsport.io/checkout/6040/subscription/51689?force=true",
  ELITE_URL: "https://backoffice.bsport.io/checkout/6040/subscription/51690?force=true",
  ELITEPLUS_URL: "https://backoffice.bsport.io/checkout/6040/subscription/53073?force=true",
  SINGLE_CLASS_URL: "https://backoffice.bsport.io/customer/payment/pass/760064/?membership=6040&force=true",
  PACK_5_URL: "https://backoffice.bsport.io/customer/payment/pass/763220/?membership=6040&force=true",
  PACK_10_URL: "https://backoffice.bsport.io/customer/payment/pass/763222/?membership=6040&force=true",
};

export const CONTACT = {
  city: "Amsterdam",
  address: "Buitenveldertselaan 120, 1081 AB Amsterdam",
  email: "info@maisoncore.nl",
  phone: "+31 6 42 33 54 59",
  phoneRaw: "+31642335459",
  whatsapp: "https://wa.me/31642335459",
  instagram: "https://www.instagram.com/maisoncore.studio/",
  instagramHandle: "@maisoncore.studio",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Buitenveldertselaan+120,+1081+AB+Amsterdam",
  hours: [
    { en: "Mon – Thu", nl: "Ma – do", h: "06:00 – 21:00" },
    { en: "Fri – Sun", nl: "Vr – zo", h: "07:00 – 13:00" },
  ],
};

export const PRICING = {
  intro: { price: "€59", classes: "3 classes" },
  memberships: [
    { key: "classic", name: "Classic", freq: "1× per week", price: "€99", url: "CLASSIC_URL" },
    { key: "signature", name: "Signature", freq: "2× per week", price: "€179", url: "SIGNATURE_URL", featured: true },
    { key: "elite", name: "Elite", freq: "3× per week", price: "€229", url: "ELITE_URL" },
  ],
  packs: [
    { name: "5 Group Class Pack", detail: "5 classes", price: "€165", url: "PACK_5_URL" },
    { name: "10 Group Class Pack", detail: "10 classes", price: "€310", url: "PACK_10_URL" },
  ],
  dropIn: { name: "Single Class", price: "€35", url: "SINGLE_CLASS_URL" },
};

// Real client testimonials (bilingual). `original` marks the language the review was written in.
export const TESTIMONIALS = [
  {
    name: "Fir",
    original: "nl",
    en: "Such a great class with Helena. Her experience really shows, and she brings such positive energy to the studio. The instructions were clear, she considered everyone's level and created a wonderful atmosphere. I felt genuinely challenged while still feeling completely at ease.",
    nl: "Hele fijne les gehad bij Helena vandaag! Je merkt aan alles dat ze ruime ervaring heeft in het lesgeven en een hele fijne, positieve energie uitstraalt. De uitleg was duidelijk, ze hield goed rekening met ieders niveau en zorgde voor een fijne sfeer. Ik voelde me echt uitgedaagd, maar tegelijkertijd helemaal op mijn gemak.",
  },
  {
    name: "Victoria Gardeva",
    original: "en",
    en: "I had a lovely class there while visiting Amsterdam! Would 100% recommend, the class had depth and foundation to it which is always something to look for in a Pilates session! I will surely visit again if I go back to Amsterdam!",
    nl: "Ik heb hier tijdens mijn bezoek aan Amsterdam een heerlijke les gevolgd. Absoluut een aanrader. De les had diepgang en een sterke basis, precies wat ik zoek in een goede Pilatesles. Als ik weer in Amsterdam ben, kom ik zeker terug!",
  },
  {
    name: "Mirne Kappelhoff",
    original: "nl",
    en: "A beautiful, welcoming studio. You receive individual attention and the classes are challenging while still feeling accessible.",
    nl: "Hele mooie, fijne studio. Er is individuele aandacht voor je en de lessen zijn uitdagend maar goed te doen.",
  },
  {
    name: "Lara",
    original: "en",
    en: "Loved everything about this place! Beautiful studio, great vibe, and an amazing instructor. Highly recommend!",
    nl: "Alles aan deze plek klopt! Een prachtige studio, fijne sfeer en een geweldige instructeur. Absoluut een aanrader!",
  },
  {
    name: "M.",
    original: "nl",
    en: "I've now taken three Sunday morning classes with Zaina and I'm very enthusiastic. The classes are professional and enjoyable, the studio is calm and atmospheric, and the overall experience is very welcoming. I love coming back and would definitely recommend Maison Core.",
    nl: "Ik heb inmiddels 3 keer op de zondagochtend bij Zaina een les hier gedaan en ben heel enthousiast! De lessen zijn fijn en professioneel, de locatie is rustig en sfeervol en de sfeer is erg prettig. Ik kom hier graag terug en kan het zeker aanraden.",
  },
];

export const PRIVATE = [
  { key: "solo", name: "Maison Core Private — 1:1", nameNl: "Maison Core Privé — 1:1", price: "€99" },
  { key: "duo", name: "Maison Core Duo Private", nameNl: "Maison Core Duo Privé", price: "€140" },
  { key: "trio", name: "Maison Core Trio Private", nameNl: "Maison Core Trio Privé", price: "€165" },
];

export const EVENTS = {
  upcoming: [
    { id: "e1", title: "Event title — placeholder", date: "Date TBC", time: "Time TBC", location: "Maison Core, Amsterdam", desc: "Short editorial description — placeholder for a real Maison Core event.", image: IMAGES.movement2, hidden: true },
  ],
  past: [
    { id: "p1", title: "Past event — placeholder", date: "Date TBC", time: "", location: "Maison Core, Amsterdam", desc: "Placeholder for a past community moment.", image: IMAGES.arch1, hidden: true },
  ],
};
